import { DashboardParamsProviders } from "@/context/DashboardParamsProviders";
import { FieldCustomizationOverrideProvider } from "@/context/FieldCustomizationOverrideContext";
import { Outlet, useLocation } from "react-router";

const EditForms = () => {
  const entity = useLocation().pathname.split("/")[2];

  return (
    <FieldCustomizationOverrideProvider>
      {entity ? (
        <DashboardParamsProviders
          persistInSearchParams={false}
          key={entity}
          storageKey={entity}
        >
          <Outlet />
          <div className="h-[100px]" />
        </DashboardParamsProviders>
      ) : (
        <Outlet />
      )}
    </FieldCustomizationOverrideProvider>
  );
};

export default EditForms;
